import { useFieldArray, useFormContext } from 'react-hook-form'
import { TiDeleteOutline } from 'react-icons/ti'
import { MdAdd } from 'react-icons/md'
import { InputText } from 'components/atoms/inputs/InputText'
import { InformationTip } from 'components/atoms/tooltips/InformationTip'

const thClass =
  'border-b-2 border-[#ddd] bg-[#f8f9fa] px-2 py-2 text-left text-sm font-medium text-[#666]'

export const SalesPersons = (): JSX.Element => {
  const { control } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'sales'
  })
  const handleAdd = () => {
    append({
      fullName: '',
      department: '',
      cellPhone: '',
      post: '',
      mail: ''
    })
  }
  return (
    <div className={'mt-8'}>
      <h3 className={'mb-4 text-base font-semibold text-[#555]'}>営業情報</h3>
      <table className={'w-full border-collapse'}>
        <thead>
          <tr>
            <th className={thClass}>
              名前 <span className={'text-xs text-red-500'}>*</span>
            </th>
            <th className={thClass}>部署</th>
            <th className={thClass}>役職</th>
            <th className={thClass}>
              <span className={'inline-flex items-center gap-1'}>
                電話番号
                <InformationTip
                  dataId={'salesPhoneNumber'}
                  discription={'ハイフンなしで入力してください。'}
                />
              </span>
            </th>
            <th className={thClass}>
              メールアドレス <span className={'text-xs text-red-500'}>*</span>
            </th>
            <th className={`${thClass} w-10`}></th>
          </tr>
        </thead>
        <tbody>
          {fields.map((field, index) => (
            <tr key={index}>
              {[
                `sales.${index}.fullName`,
                `sales.${index}.department`,
                `sales.${index}.post`,
                `sales.${index}.cellPhone`,
                `sales.${index}.mail`
              ].map((name, idx) => (
                <td className={'px-2 py-2'} key={idx}>
                  <InputText name={name} />
                </td>
              ))}
              <td className={'w-10 px-2 py-2 align-top'}>
                <button
                  type={'button'}
                  className={
                    'mt-[6px] text-red-500 transition-colors hover:text-red-700 disabled:text-gray-300'
                  }
                  onClick={() => {
                    fields.length > 1 && remove(index)
                  }}
                  disabled={fields.length === 1}
                >
                  <TiDeleteOutline size={22} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button
        type={'button'}
        className={
          'mt-3 inline-flex items-center gap-1.5 rounded border border-[#ddd] bg-white px-4 py-2 text-sm font-medium text-[#666] transition-colors hover:bg-[#f8f9fa]'
        }
        onClick={handleAdd}
      >
        <MdAdd size={18} /> ユーザー追加
      </button>
    </div>
  )
}
